module.exports = __webpack_public_path__ + "static/ENmobSlide2-f770a699fe2ef035e3d251f6a19f96e9.jpg";